import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { getRootReducer } from './reducer.js';
let globalStore = null;
const isDevelopment = process.env.NODE_ENV === 'development';
export function configureStore(initialState, additionalMiddlewares = []) {
    const middlewares = [thunk, ...additionalMiddlewares];
    if (isDevelopment) {
        // Note: logger must be the last middleware in chain,
        // otherwise it will log thunk and promise, not actual actions
        const logger = createLogger({ collapsed: true });
        middlewares.push(logger);
    }
    const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
        compose;
    const newStore = createStore(getRootReducer(), initialState, composeEnhancers(applyMiddleware(...middlewares)));
    if (globalStore && isDevelopment) {
        console.warn('@tmapy/core/configureStore(): Was called more than once!');
    }
    globalStore = newStore;
    return newStore;
}
export const isStoreConfigured = () => !!globalStore;
export function getStore() {
    if (!globalStore) {
        throw new Error('@tmapy/core/getStore(): Store not configured yet!');
    }
    return globalStore;
}
//# sourceMappingURL=configureStore.js.map